import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { Campaign3Service } from '../services/campaign3.service';
import { Campaign3BreadcrumbComponent } from '../components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';
import { BreadCrumbModel } from '../models/campaign-3-breadcrumb.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Campaign3TestService } from '../services/campaign3testservice';
import { Observable } from 'rxjs';
import { Campaign3KontableComponent } from '../components/campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Campaign } from '../models/campaign-3.model';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { ActionStateService } from '../services/actionstate.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';







@Component({
    selector: 'app-campaign-list3',
    templateUrl: './campaign-list3.component.html',
    styleUrls: ['./campaign-list3.component.css']
})
export class CampaignList3Component implements OnInit {

    @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
    @ViewChild('campaignlist') kontableComponent: Campaign3KontableComponent;
    breadcrumbs: Array<BreadCrumbModel> = [];
    paginationType = KontableComponent.ServerPagination;
    dateFilter = KontableComponent.DateFilter;
    numberFilter = KontableComponent.NumberFilter;
    textFilter = KontableComponent.TextFilter;
    selectFilter = KontableComponent.SelectFilter;
    noFilter = KontableComponent.NoFilter;
    pageSubject = "campaign";
    showPopupEdit = false;
    showPopupCreate = false;
    readyTable = false;
    startDate;
    endDate;
    showMenu = false;
    currentOpenedRow;
    campaignActionList = [];
    newCampaign: boolean = false;
    allActionList;

    campaignType: Array<{ label: string, value: string }>;
    statusList: Array<{ label: string, value: string }>;
    budgetList: Array<{ label: string, value: string }>;

    campaignActions;
    singleCampaign: Campaign3Campaign;
    singleCampaignStartDate: Date;
    singleCampaignEndDate: Date;

    fieldModel = {
        campaign_name: "campaign_name",
        campaign_description: "campaign_description",
        start_date: "start_date",
        end_date: "end_date",
        budget_type: "budget_type",
        budget_value: "budget_value",
        campaign_type: "campaign_type"
    }

    constructor(
        public campaign2Service: Campaign2Service,
        public campaign3Service: Campaign3Service,
        public testService: Campaign3TestService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public srvCalendar: CalendarTranslateService,
        public  actionStateService: ActionStateService,
        private srvNotify: MessageService,
        private translate: TranslateService
    ) { }




    ngOnInit(): void {

       
        this.newCampaign = this.activatedRoute.snapshot.params['new'] == "new" ? true : false;
        const campaignTipeSub = this.testService.getCampaignType();
        const statusSub = this.testService.getCampaignStatus();
        const budgetSub = this.testService.getBudgetType();
        const actionSub = this.testService.getAllActions();
       // const FAV_LIST= this.campaign3Service.checkIfActionIsFavourite()
        this.campaignType = [];
        this.statusList = [];
        this.budgetList = [];
        this.allActionList = [];
        this.campaignType.push({ label: '', value: null });
        this.statusList.push({ label: '', value: null });
        this.budgetList.push({ label: '', value: null });

        this.initBreadCrumbs();

        Observable.zip(
            campaignTipeSub,
            statusSub,
            budgetSub,
            actionSub,
            
        ).subscribe(
            ([resCampaignType, resCampaignStatus, resCampaignBudgettype, resActionSub]) => {
                if (resCampaignType && resCampaignStatus && resCampaignBudgettype && actionSub) {

                    for (const campaignType of resCampaignType.data) {
                        this.campaignType.push({ label: campaignType.description, value: campaignType.id.toString() });
                    }
                    for (const status of resCampaignStatus.data) {
                        this.statusList.push({ label: status.description, value: status.id.toString() });
                    }
                    for (const campaignBudget of resCampaignBudgettype.data) {
                        this.budgetList.push({ label: campaignBudget.description, value: campaignBudget.id.toString() });
                    }
                    for (const action of resActionSub.data) {
                        this.allActionList.push(action);
                    }
                    this.readyTable = true;
                }
          
                if (this.newCampaign) {
                    this.onOpenCreation();
                }
                setTimeout(() => {
                    const currentCampaignId = this.actionStateService.getCurrentCampaignId();
                    if (currentCampaignId) {
                        this.kontableComponent.findAgainCampaign(currentCampaignId);
                        this.actionStateService.setCurrentCampaignId(null);
                    }
                  
                }, 100);
            },
        );

    }
    /* fetcha la singola campagna alla pressione dell'edit */
    fetchSingleCampaign(campaignId: number): void {
        this.testService.getSingleCampaign(campaignId).subscribe(
            (res) => {
                console.log('SingleCampaign********', res.data[0]);
                this.singleCampaign = res.data[0];
                this.singleCampaignStartDate = new Date(res.data[0].start_date);
                this.singleCampaignEndDate = new Date(res.data[0].end_date);
                this.showPopupEdit = true;
            }
        )
    }

    getStatusDescription(row): string {

        let description = "";
        let index = this.statusList.findIndex(x => x.value == row.campaign_status_id);
        if (index > -1) {
            description = this.statusList[index].label;
        } else {
            console.log("errore nel trovare la descrizione degli stati");
        }
        return description;
    }

    getCampaignDescription(campaignTypeId: string): string {
        let description = "";
        let index = this.campaignType.findIndex(x => x.value == campaignTypeId);
        if (index > -1) {
            description = this.campaignType[index].label;
        } else {
            console.log("errore nel trovare la descrizione delle campagne");
        }
        return description;
    }

    /* funzione da eliminare, era per analizzare la chiamata che veniva già effettuata */
    fetchCampaignData(): void {
        this.testService.getCampaignData().subscribe(
            (response: any) => {
                let statusList = []
                // Estrae i dati dalla proprietà 'data'
                const data = response.data;
                data.forEach(val => statusList.push(val.flg_state));
                // Estrae il numero totale di record dalla proprietà 'metadata'
                const totalRecord = response.metadata.total;
            },
            (error) => {
                console.error('Errore durante il recupero dei dati delle campagne:', error);
            }
        );
    }
    
    breadcrumbClicked(breadcrumb:BreadCrumbModel) {
        if (breadcrumb.routerLink) {
            this.router.navigate([breadcrumb.routerLink]);
          } else {
            console.log("nessuna route implementata");
          }
    }


    initBreadCrumbs() {
        let bc1 = new BreadCrumbModel();
        bc1.code = "bc1";
        bc1.description = "Campagne";
        bc1.routerLink= "/campaign-list-3";
        this.breadcrumbs.push(bc1);
    }

    onOpenEdit(id: number) {
        if (id === undefined) {
            console.error("ID is undefined!");
            return;
        }
        this.fetchSingleCampaign(id);
    }

    onOpenCreation() {
        if (this.showPopupCreate) {
            this.showPopupCreate = false;
        } else {
            this.showPopupCreate = true;
        }
    }

    onActionTable() {
        this.router.navigate(["/action-list-3"]);
    }

    onClosePopupEdit() {
        this.showPopupEdit = false;
    }

    onClosePopupCreation() {
        this.showPopupCreate = false;
    }

    //intercetto l'evento di chiusura filtri e pulisco anche quelli esterni alla tabella
    clearDateFields() {
        this.startDate = null;
        this.endDate = null;
    }
    clearDateFilter() {
        this.startDate = null;
        this.endDate = null;
      }
    refreshAfterEdit() {
        this.kontableComponent.refresh();
    }

    onCheckEndCampaign(row) {
        let retValue = false;
        if (row.end_date && new Date(row.end_date) < new Date()) {
            retValue = true;
        
        }
        if (row.flg_state === "1") {
            retValue = true;
          }
        return retValue;
    }

   

    checkAlreadyDeleted(row){
       let  retValue = false
       let  campaign = row;
         // Aggiungi la condizione per flg_state
         if (campaign.flg_state === "1") {
            retValue = true;
          }
          return retValue;
    }

    //conto il numero totale di azioni per campagnia
    getNumberOfAction(row: any): number {
        const actionsForCampaign = this.allActionList.filter(action => action.campaign_id === row.id);
        return actionsForCampaign.length;
    }

    //todo da implementare
    getStatusDotClass(row: any): string {

        let statusId = row.campaign_status_id;

        if (statusId == null) {
            return '';
        }

        let statusDescr = this.statusList.filter(action => action.value === statusId.toString());
        let statusDescription = statusDescr.length > 0 ? statusDescr[0].label : null;
        let cssClass = ''

        switch (statusDescription) {
            case 'IN CREAZIONE':
                cssClass = 'status-dot-green'
                break;
            case 'DA PUBBLICARE':
                cssClass = 'status-dot-orange'
                break;
            case 'PUBBLICATA':
                cssClass = 'status-dot-green-border'
                break;
            case 'PUBBLICAZIONE INTERROTTA':
                cssClass = 'status-dot-red'
                break;
            case 'IN CORSO':
                cssClass = 'status-dot-green'
                break;
            case 'SCADUTA':
                cssClass = 'status-dot-grey'
                break;
            default:
                cssClass = ''
                break;
        }
        return cssClass;
    }
    //Nuova funzione per calcolare date 30-07-2025
checkExpiredCampaign(row: any) {
    let retValue = "";

    // Normalizzo le date per ignorare l'orario
    if (row.end_date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const endDate = new Date(row.end_date);
        endDate.setHours(0, 0, 0, 0);

        if (endDate < today) {
            retValue = "disabled";
        }
    }

    // Aggiungo controllo sul flg_state
    if (row.flg_state === "1") {
        retValue = "disabled";
    }

    return retValue;
}

    onOpenActions(row: any) {

    }
 
    a2() {

    }


    getBudgetType(budget_type_id: string): string {
        let budgetDescription = "";
        let index = this.budgetList.findIndex(x => x.value == budget_type_id);
        if (index > -1) {
            budgetDescription = this.budgetList[index].label;
        } else {
            console.log("errore nel trovare la descrizione delle campagne");
        }
        return budgetDescription;
    }

    //todo quando clicco fuori deve chiudersi 
    toggleMenu(id: number) {

        if (this.showMenu && this.currentOpenedRow !== id) {
            this.showMenu = false;
        }

        this.currentOpenedRow = id;
        this.showMenu = !this.showMenu;
    }

    // Aggiungi il listener agli eventi del documento
    @HostListener('document:click', ['$event'])
    onClick(event: any) {
        // Verifica se il clic è avvenuto al di fuori del dropdown-menu aperto
        if (!event.target.closest('.dropdown-menu') && event.target.closest('.d-flex') === null) {
            this.showMenu = false;
        }
    }


    fetchCampaignActions(row: any) {
        return this.testService.getCampaignActions(row.id);
    }



    selectedCampaignActions: any;
    campaignToDelete: any;
    displayDeleteDialog: boolean = false;




    deleteCampaign(row: any) {
        this.campaignToDelete = row;
        this.fetchCampaignActions(row).subscribe(
            (res) => {
                this.selectedCampaignActions = res;
                if (this.selectedCampaignActions.data && this.selectedCampaignActions.data.length == 0) {
                    this.displayDeleteDialog = true;
                } else {
                    this.srvNotify.add({
                        severity: 'error',
                        summary: this.translate.instant('common.error'), 
                        detail: this.translate.instant('campaign.cannot_delete_campaign_with_actions') 
                    });
                    
                }
            },
            (error) => {
                console.error('Errore durante il recupero di azioni delle campagne:', error);
            }
        );
    }

    closePopupDelete() {
        this.displayDeleteDialog = false;
    }


    onDefinitiveDelete(row: any) {
        this.testService.deleteCampaign(row.id).subscribe(() => {
            this.displayDeleteDialog = false;
            this.srvNotify.add({
                severity: 'success',
                summary: this.translate.instant('common.success'), 
                detail: this.translate.instant('campaign.campaign_delete_success'),
                life : 5000
            });
            this.kontableComponent.refresh();
        });
    }
      



}





// WEBPACK FOOTER //
// ./src/app/views/campaign-3/campaign-list/campaign-list3.component.ts